
// Load more pagination for collection pages
if (document.querySelector('.CollectionInner__Products')) {
  document.querySelector('.CollectionInner__Products').addEventListener('click', function (e) {
    if (e.target && e.target.id === 'load-more-items') {
      updatePageContents(e.target.dataset.nextPage);
    }
  });

  function updatePageContents(targetUrl) {
    let nextURl = document.querySelector("[data-next-url]")
    if (targetUrl) {
      // Get current page value and update URLs when load more is clicked
      const currentUrl = new URL(window.location);
      const urlParams = new URLSearchParams(currentUrl.search);
      const currentPageValue = parseInt(urlParams.get('page') || '1');
      
      // Update the URL to reflect the new page
      urlParams.set('page', currentPageValue + 1);

      const newUrl = `${currentUrl.pathname}?${urlParams.toString()}`;
      
      // Update browser history with the correct URL
      window.history.pushState({param: Shopify.queryParams}, document.title, newUrl);
      fetch(targetUrl)
        .then(function (response) {
          // When the page is loaded convert it to text
          return response.text();
        })
        .then(function (html) {
          // Initialize the DOM parser
          let parser = new DOMParser();

          // Parse the text
          let fetchedPage = parser.parseFromString(html, 'text/html');

          let newCards = fetchedPage.querySelectorAll('.product-list__items .Grid__Cell:not(.product-grid-item-placeholder)');
          newCards.forEach((newCard) => {
            document.querySelector('.product-list__items.ProductList')?.appendChild(newCard);
          });

          if (fetchedPage.querySelector('#load-more-items')) {
            document.querySelector('#load-more-items').dataset.nextPage =
              fetchedPage.querySelector('#load-more-items').dataset.nextPage;

            document.querySelector('#visible-items').innerHTML =
              fetchedPage.querySelector('#visible-items').innerHTML;
              
            // Update the next URL for future loads
            nextURl.value = fetchedPage.querySelector('#load-more-items').dataset.nextPage;
          } else {
            document.querySelector('#load-more-items')?.classList.add('hidden');
            document.querySelector('#visible-items')?.classList.add('hidden');
          }

          //reinit yotpo widget star ratings
          window.yotpoWidgetsContainer?.initWidgets();
        }).then(() => {
          const event = new CustomEvent('page-contents:updated');
          document.dispatchEvent(event);
        })
        .catch(function (err) {
          console.log('Failed to fetch page: ', err);
        });
    }
  }
}

async function addPreviousCollectionProducts() {
  const selectors = {
    products: ".product-list__items .Grid__Cell:not(.product-grid-item-placeholder)",
    productGrid: "div[data-products-grid] .ProductListWrapper .ProductList",
  };

  const previousProductDivs = document.querySelectorAll(".js-collection-previous-products");
  
  const reversedPreviousProductDivs = Array.from(previousProductDivs);
  const previousProducts = [];

  const promises = reversedPreviousProductDivs.map((div) => {
    const url = div.getAttribute("data-url");
    return fetch(url).then((response) => response.text());
  });

  const responses = await Promise.all(promises);

  responses.forEach((html, index) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const products = doc.querySelectorAll(selectors.products);
    previousProducts.push(...products);
  });
  
  const productGrid = document.querySelector(selectors.productGrid);
  const placeholders = [...document.querySelectorAll(".product-grid-item-placeholder")];

  previousProducts.forEach((product, index) => {
    if (placeholders[index]) {
      placeholders[index].outerHTML = product.outerHTML;
    } else {
      productGrid.prepend(product);
    }
  });

  console.log("Previous products added:", previousProducts.length);
  console.log("Placeholders removed:", placeholders.length);

  placeholders.slice(previousProducts.length).forEach((placeholder) => {
    placeholder.remove();
  });
}

window.addEventListener("popstate", function(event) {
  if (document.querySelector('.CollectionInner__Products')) {
    const scrollPosition = window.pageYOffset;
    sessionStorage.setItem('collectionScrollPosition', scrollPosition);
    
    window.location.reload();
  }
});

window.addEventListener('load', function() {
  const savedScrollPosition = sessionStorage.getItem('collectionScrollPosition');
  if (savedScrollPosition && document.querySelector('.CollectionInner__Products')) {
    sessionStorage.removeItem('collectionScrollPosition');
    
    scrollToProducts(parseInt(savedScrollPosition));
  }
});

function scrollToProducts(scrollPosition) {
  const productsContainer = document.querySelector('.CollectionInner__Products');
  const collectionNav = document.querySelector('.CollectionToolbar') || document.querySelector('.collection-toolbar');
  const stickyHeader = document.querySelector('.Header') || document.querySelector('header');
  
  if (productsContainer) {
    const navHeight = collectionNav ? collectionNav.offsetHeight : 0;
    const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
    
    const targetScrollPosition = scrollPosition - navHeight - headerHeight;
    
    window.scrollTo({
      top: Math.max(0, targetScrollPosition),
      behavior: 'smooth'
    });
  }
}

(async function () {
  await addPreviousCollectionProducts();
})();